
import {ServerProdApi , ServerProdApidl , ServerDistApi } from '../../../src/group-cloud/network/ServerBizApi';
import {Mod_Roles} from "./Roles";

export class Mod_Clients {
    //旧客户管理接口
    public static async getOldClientList(page, type, keyword) {

        // let url = 'member/auth_center/yooz/user/list';
        let url = 'user/find/getClientOrStore';
        let formData =  {
            page: page,
            pageSize: 20,
            user_type_in:type,
            search: keyword
        };
        let response = await ServerProdApidl.send(url, formData);
        //修改返回
        return response.result;

    }
    public static async getOldClientListaaa(page, type, keyword,e) {

        let url = '/yoozClient/getClientInfoList';
        let formData
        if(e==0){
            formData =  {
                page: page,
                page_num: 20,
                data:{
                    phone: keyword
                }
            };
        }else{
            formData =  {
                page: page,
                page_num: 20,
                data:{
                    outCode: keyword
                }
            };
        }
        let response = await ServerDistApi.send(url, formData);
        return response.result;

    }
  //修改客户管理接口
    public static async getClientList(selectTJ) {

        // let url = 'auth_center/yooz/user/list';
        let url='/yoozClient/getClientInfoList';
        let formData =  {
            ...selectTJ
        };
        // let response = await ServerProdApi.send(url, formData);
        let response = await ServerDistApi.send(url, formData);
        return response.result;

    }

   //客户导出接口
    public static async exportData(params) {
        let url = '/yoozClient/clinetExportExecl';
        let formData =  {
           ...params
        };
        let response = await ServerDistApi.send(url, formData);
        return response.result;
    }

     //查询条件接口
     public static async conditionQuery(listData) {
        let url = '/yoozClient/getQueryList';
        let formData =  {
            yoozClientList:listData,
        };
        let response = await ServerDistApi.get(url, formData);
        return response.result;
    }



    public static async getClientInfo(cid) {

        // let url = 'auth_center/yooz/user/info';
        let url = 'member/auth_center/yooz/user/listbyids';
        let formData =  {
            clientIds: [cid],
        };
        let response = await ServerProdApidl.send(url, formData);

        let ret;

        ret = {};

        //修改返回
        if (response && response.result[0]) {
            ret = response.result[0];
        }

        return ret;

    }

    public static getMemberWhString(record) {

        let ret = '';

        let roles = [], idx;
        if (record && record.warehouse && record.warehouse.length) {

            for (idx = 0; idx < record.warehouse.length; idx++) {
                roles.push(record.warehouse[idx].name);
            }

            if (roles.length) {
                ret = roles.join(',');
            }
        }

        return ret;

    }

    //获取client_id
    public static async getClientUserInfo() {
      let url = 'member/find/current';
      let response = await ServerProdApidl.send(url, {});
      return response;
    }
}


